import Vue from 'vue';
import App from './App.vue';
import { router } from './router/routes.js';
import firebase from "firebase/app";

Vue.config.productionTip = false;

var firebaseConfig = {
  apiKey: "AIzaSyCxuVpN-zTYEx0Hqa0PAqUaD-hG4Ist5Z0",
  authDomain: "maxtonehlert.firebaseapp.com",
  databaseURL: "https://maxtonehlert.firebaseio.com",
  projectId: "maxtonehlert",
  storageBucket: "maxtonehlert.appspot.com",
  messagingSenderId: "683646542417",
  appId: "1:683646542417:web:35b03b661d0a4184228e70",
  measurementId: "G-WCC7D8N0BL",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// const db = firebase.firestore();

let app;

firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }
});


// new Vue({
//   router,
//   render: h => h(App),
// }).$mount('#app')
